import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { setUser } from "../../../../store/action/auth";
import HttpService from "../../../../services/http_service/HttpService";
import Http from "../../../../services/http/Http";
import Item from "./Item";
import { Row } from "./style";
import Loading from "./loading";

const Paymethods = (props) => {
  const { user } = props;

  const [isLoadingGetData, setIsLoadingGetData] = useState(false);
  const [paymethods, setPaymethods] = useState([]);

  const getPaymethod = useCallback(() => {
    setIsLoadingGetData(true);

    HttpService(user?.token)
      .get("paymethods")
      .then((response) => {
        setPaymethods(response.data?.entity);
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingGetData(false);
      });
  }, [user, props]);

  useEffect(() => {
    window.scrollTo(0, 0);

    getPaymethod();
  }, [getPaymethod]);

  return (
    <>
      {isLoadingGetData ? (
        <Loading />
      ) : paymethods ? (
        <Row className="row no-gutters">
          {paymethods.map((paymethod, index) => (
            <Item key={index} data={paymethod} index={index} />
          ))}
        </Row>
      ) : (
        false
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, { setUser })(Paymethods);
